/**
 * Central contact registry — Gold Petroleum FZ LLC.
 * Restructured 2026-09-16: telephone is a company-level line, NOT tied to a person.
 * Country code confirmed 2026-09-19 by owner: +972.
 * Grep the codebase for hardcoded phones/emails — they should all read from here.
 */

export const contact = {
  company_phone: {
    label: "Company telephone",
    raw: "+972 56 585 0606",
    tel: "+972565850606",
  },
  sales_email: {
    label: "Sales enquiries",
    address: "sales@gpfzllc.com",
  },
  general_email: {
    label: "General enquiries",
    address: "admin@gpfzllc.com",
  },
  leadership: {
    name: "Ken Salvadore",
    title: "President & CEO",
    // NO phone here. Do not attach a personal telephone to the leadership entry.
  },
  sales_contact: {
    name: "Fabio",
    role: "Sales",
    region: "Canada",
    raw: "+1 416 277 5262",
    tel: "+14162775262",
  },
};

// Backwards-compat helpers used by older imports. Return the new company line —
// old callers looking for "Ken's primary phone" now render the unnamed company line.
export const CONTACT_STATIC = contact;
export function kenPrimary() { return contact.company_phone; }
export function kenAlt() { return null; }
export function telHref(raw) {
  if (!raw) return "";
  const cleaned = raw.replace(/[^0-9+]/g, "");
  return cleaned.startsWith("+") ? cleaned : `+${cleaned}`;
}
export function mergeContact() { return contact; }
